import CustomerRequestModel from "#src/models/CustomerRequestModel.ts";
import { InvoiceItemModel } from "#src/models/InvoiceItemModel.ts";
import {
  coupons,
  Event,
  membership,
  MembershipStatus,
  type StudentInfoRequestResponsePayload,
} from "#types/code-generator.ts";
import MembershipOfferingModel from "./MembershipOfferingModel.ts";
import UserModel from "./UserModel.ts";

export const isMembership = (item): item is MembershipModel =>
  item instanceof MembershipModel || item.nextInvoiceDate !== undefined;

class MembershipModel {
  accountOwner: UserModel = null;
  accountOwnerId: string;
  checkIns: membership["membership"]["checkIns"] = [];
  coupons: coupons["coupons"];
  createdAt: Date;
  createdBy: UserModel;
  customerRequest: CustomerRequestModel;
  dateApproved: Date;
  disableAutoRecharge: boolean = false;
  events: Event[] = [];
  finalDate: Date;
  id: string;
  invoiceItems: InvoiceItemModel[];
  nextInvoiceDate: Date;
  offering: MembershipOfferingModel = null;
  offeringId: string;
  roster: UserModel[] = [];
  status: MembershipStatus = MembershipStatus.Pending;
  studentInfoRequestResponses: StudentInfoRequestResponsePayload[] = [];
  visits: number = 0;
  updatedAt: Date;

  constructor(data) {
    Object.assign(this, data);

    if (data?.offering) {
      this.offering = new MembershipOfferingModel(data.offering);
    }
  }
}

export default MembershipModel;
